import { client } from '../../store/operations';
import { ROUTES } from './constants';
import { any, equals } from '../../utils';
import { apolloStore } from '../../app/apollo-client-instance';

// TODO: Copied from home-details. Consolidate.
export function getClientState(store = apolloStore()) {
  return store.query(client.currentMove()).then(({ data: { CurrentMove } }) =>
    store.query(client.moveIqMove(CurrentMove.id)).then(({ data }) => ({
      ...data,
      currentMove: CurrentMove,
    }))
  );
}

export const isLocal = equals(ROUTES.local);
export const isLongDistance = equals(ROUTES.longDistance);
export const isLargeHome = equals(ROUTES.largeHome);
export const isLargeHomeOrLongDistance = any([isLargeHome, isLongDistance]);
